module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-level"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('h5', {
    staticClass: "text-white text-center"
  }, [_vm._v("Select an education level")]), _vm._v(" "), _vm._l((_vm.options.slice(0, 3)), function(option) {
    return _c('q-list-item', {
      attrs: {
        "link": "",
        "item": option
      },
      nativeOn: {
        "click": function($event) {
          _vm.onInput(option.value)
        }
      }
    })
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-white text-center branding"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/assets/SP_Logo.svg"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-16acda16", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16acda16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionView/Slide/SchoolLevel.vue
// module id = 844
// module chunks = 0